import app from "../data/base";

async function saveGruppo(inputobject) {
  console.log(inputobject);
  const body = `${JSON.stringify(inputobject)}`;
  try {
    const response = await app.methods.callserver('api/admin/group', 'POST', null, body, true);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

async function deleteGruppo(idgruppo) {
  try{
      console.log(idgruppo);
      const response = await app.methods.callserver('api/admin/group/' + idgruppo,'DELETE',false, null);
      console.log(response)
      if(response.status=='201' || response.status=='200'){
          return true;
      }else{
          return false;
      }

  }catch(err){
      console.log('Error during saveUtente');
      console.log(err);
      return false;
  }
}

async function loadGruppi() {
  console.log('LoadGruppi')
  try {
    const response = await app.methods.callserver('api/admin/group', 'GET', null, null, true);
    return await response.json();
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export const gruppi = {
  methods: {
    loadGruppi,
    saveGruppo,
    deleteGruppo
  }
}
